module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_7.37ea6589.pdf";